/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class NitroSwitchService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param dcs 
     * @param msisdn 
     * @param psms 
     * @param esmcclass 
     * @param msg 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public nitroSwitchSubscriptionNotification(dcs: any, msisdn?: string, psms?: string, esmcclass?: string, msg?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public nitroSwitchSubscriptionNotification(dcs: any, msisdn?: string, psms?: string, esmcclass?: string, msg?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public nitroSwitchSubscriptionNotification(dcs: any, msisdn?: string, psms?: string, esmcclass?: string, msg?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public nitroSwitchSubscriptionNotification(dcs: any, msisdn?: string, psms?: string, esmcclass?: string, msg?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (dcs === null || dcs === undefined) {
            throw new Error('Required parameter dcs was null or undefined when calling nitroSwitchSubscriptionNotification.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (msisdn !== undefined && msisdn !== null) {
            queryParameters = queryParameters.set('msisdn', <any>msisdn);
        }
        if (psms !== undefined && psms !== null) {
            queryParameters = queryParameters.set('psms', <any>psms);
        }
        if (esmcclass !== undefined && esmcclass !== null) {
            queryParameters = queryParameters.set('esmcclass', <any>esmcclass);
        }
        if (msg !== undefined && msg !== null) {
            queryParameters = queryParameters.set('msg', <any>msg);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<string>(`${this.basePath}/api/NitroSwitch/mo`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
